import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

function fmt(v) {
  if (v == null) return "";
  return String(v);
}

function fmtNum(v) {
  if (v == null || v === "") return "";
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  return n.toLocaleString("en-US"); // 1,000
}

function pad(n) {
  const x = String(n || "");
  return x.length === 1 ? `0${x}` : x;
}

function formatDate(d) {
  if (!d) return "";
  const dt = new Date(d);
  if (Number.isNaN(dt.getTime())) return fmt(d);
  return `${pad(dt.getDate())}-${["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][dt.getMonth()]}-${dt.getFullYear()}`;
}

export default function generateBolsStatusByFlightPdf(payload) {
  const header = payload?.header || payload?.data?.header || {};
  const items =
    Array.isArray(payload?.items) ? payload.items :
    Array.isArray(payload?.data?.items) ? payload.data.items :
    [];

  const totals =
    payload?.totals ||
    payload?.data?.totals ||
    {
      total_bols: items.length,
      total_packages: items.reduce((s, x) => s + Number(x?.number_of_packages || 0), 0),
      total_gross_mass: items.reduce((s, x) => s + Number(x?.gross_mass || 0), 0),
    };

  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();

  doc.setFontSize(16);
  doc.text("BOL Status Report (By Flight)", pageW / 2, 40, { align: "center" });

  doc.setFontSize(10);
  const leftX = 40;
  const rightX = pageW - 40;
  const y0 = 70;

  doc.text(`Flight No: ${fmt(header.flight_no || "")}`, leftX, y0);
  doc.text(`Arrival: ${formatDate(header.date_of_arrival || "")}`, rightX, y0, { align: "right" });

  doc.text(
    `Route: ${fmt(header.place_of_departure_code || "")} - ${fmt(header.place_of_destination_code || "")}`,
    leftX,
    y0 + 14
  );

  const body = items.map((b) => [
    fmt(b.bol_reference),
    fmtNum(b.number_of_packages),
    fmtNum(b.gross_mass),
    fmt(b.goods_description),
    fmt(b.status_text || ""),
    b.is_do_issued ? "YES" : "NO",
    b.is_delivered ? "YES" : "NO",
  ]);

  autoTable(doc, {
    startY: y0 + 28,
    theme: "grid",
    head: [[
      "AWB",
      "PIECES",
      "WEIGHT",
      "NATURE OF GOODS",
      "STATUS",
      "DO",
      "DELIVERED",
    ]],
    body,
    styles: { fontSize: 9, cellPadding: 3 },
    headStyles: {
      fontStyle: "bold",
      fillColor: [30, 136, 229], // أزرق للهيدر
      textColor: 255,
    },
    didParseCell: (data) => {
      if (data.section !== "body") return;

      const row = items[data.row.index];
      const rank = Number(row?.status_rank || 9);

      // ألوان الحالات حسب الترتيب المطلوب:
      // 1) DO issued + not delivered (أصفر)
      // 2) no DO + not delivered (أحمر فاتح)
      // 3) delivered (أخضر فاتح)
      if (rank === 1) data.cell.styles.fillColor = [255, 243, 205];
      if (rank === 2) data.cell.styles.fillColor = [248, 215, 218];
      if (rank === 3) data.cell.styles.fillColor = [212, 237, 218];
    },
    columnStyles: {
      0: { cellWidth: (pageW - 80) * 0.16 },
      1: { cellWidth: (pageW - 80) * 0.10, halign: "right" },
      2: { cellWidth: (pageW - 80) * 0.10, halign: "right" },
      3: { cellWidth: (pageW - 80) * 0.34 },
      4: { cellWidth: (pageW - 80) * 0.18 },
      5: { cellWidth: (pageW - 80) * 0.06, halign: "center" },
      6: { cellWidth: (pageW - 80) * 0.06, halign: "center" },
    },
  });

  const afterY = (doc.lastAutoTable?.finalY || (y0 + 28)) + 18;
  doc.setFontSize(10);
  doc.text(
    `Totals | AWBs: ${fmtNum(totals.total_bols)}   Pieces: ${fmtNum(totals.total_packages)}   Weight: ${fmtNum(totals.total_gross_mass)}`,
    leftX,
    afterY
  );

  doc.save(`bol_status_by_flight_${fmt(header.flight_no || "")}.pdf`);
}
